import { cn } from '@/lib/utils';

interface GrainOverlayProps {
  className?: string;
  opacity?: number;
}

/** Fixed full-viewport film-grain texture — adds depth to the flat charcoal base. */
export function GrainOverlay({ className, opacity = 0.035 }: GrainOverlayProps) {
  return (
    <div
      className={cn('grain-overlay pointer-events-none fixed inset-0 z-[1] mix-blend-overlay', className)}
      style={{ opacity }}
      aria-hidden='true'
    />
  );
}

export default GrainOverlay;
